(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('programDesignationField', {
  template: '\n      <div class="program-designation-field form_field {{ $ctrl.fieldOptionSettings.containerClass || \'full\' }}">\n        <label class="form__label" _spec=\'label\'>\n          <i\n            class="form_label-icon-ok fa fa-check-circle"\n            data-ng-if="$ctrl.fieldOptionSettings.check.enabled"\n            data-ng-show="{{ $ctrl.fieldOptionSettings.check.condition }}"\n          ></i>\n          {{::$ctrl.fieldOptionSettings.label }}\n          <span class="form_label-required" data-ng-if="$ctrl.fieldOptionSettings.required"></span>\n        </label>\n  \n        <p class="form__sublabel--shifted"\n           _spec=\'sublabel\'>\n          {{::$ctrl.fieldOptionSettings.sublabel }}\n        </p>\n        \n        <typeahead-dropdown-control               \n          ng-if="$ctrl.selected"\n          fetch-action="$ctrl.getDesignations"\n          selected-item="$ctrl.selected"\n          element-index="{{::$ctrl.elementIndex}}"\n          on-item-selected="$ctrl.onItemSelected(item, model, label)"\n          on-scroll-to-bottom="$ctrl.onScrollToBottom()"\n          show-group-names="$ctrl.entity.display_group_name"\n        ></typeahead-dropdown-control>\n      </div>\n    ',
  bindings: {
    fieldOptionSettings: '=',
    model: '=',
    selectedId: '=?',
    entity: '=',
    onChange: '<',
    elementIndex: '@'
    // element index is for when there are multiple typeaheads in the DOM
    // and you want to specify which to open.
    // if elementIndex is undefined, it selects the first (at index 0)
  },
  controller: ["scCampaignsService", "designationsService", function programDesignationFieldCtrl(scCampaignsService, designationsService) {
    var _this = this;

    this.sort = null;
    this.page = 1;
    this.maxPage = false;
    this.searchTerm = '';
    this.isLoading = false;

    this.designations = {};

    this.selectDesignation = function (id, name) {
      _this.selected = {
        label: name,
        value: id
      };
      _this.selectedId = id;
      _this.model = id;
    };

    this.getDesignations = function (val) {
      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (val !== _this.searchTerm || forceUpdate) {
        _this.page = 1;
        _this.maxPage = false;
        _this.designations = {};

        _this.searchTerm = val ? val.trim() : val;
      }

      if (_this.maxPage) {
        return Promise.resolve(_this.buildTypeaheadItems());
      }

      var filter = _this.searchTerm ? 'name*=' + _this.searchTerm + ',is_active=true' : 'is_active=true';

      var designationItemsSource = _this.isCampaignContext ? _this.getCampaignDesignationItems(filter) : _this.getOrganizationDesignationItems(filter);

      _this.isLoading = true;

      return designationItemsSource.then(function (items) {
        if (_.isEmpty(items)) _this.maxPage = true;

        _this.addDesignationsByGroup(items);

        _this.isLoading = false;

        return _this.buildTypeaheadItems();
      });
    };

    this.onItemSelected = function (item) {
      _this.selectDesignation(item.id, item.name);

      // send the selected designation up to the parent component
      Object.keys(_this.designations).forEach(function (groupName) {
        var designations = _this.designations[groupName];

        var designation = designations.find(function (desg) {
          return desg.id === item.id;
        });

        if (designation) {
          _this.onChange(designation);
        }
      });
    };

    this.onScrollToBottom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.maxPage || _this.isLoading)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:

              _this.page += 1;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    // needs to return a promise so tests can await it and assert
    this.$onInit = function () {
      _this.searchTerm = '';
      _this.onChange = _this.onChange || function () {};

      _this.isCampaignContext = Object.prototype.hasOwnProperty.call(_this.entity, 'classy_mode_enabled');

      if (_this.isCampaignContext) {
        _this.displayGroupNames = _this.entity.display_group_name;
        _this.designationSortOrder = _.get(scCampaignsService, 'active.current.sort_designation_by');
        _this.sort = designationsService.parseSortOrder(_this.designationSortOrder);
      }

      if (_this.fieldOptionSettings) {
        _this.fieldOptionSettings.forceRefresh = _this.forceRefresh.bind(_this);
      }

      return _this.initializedesignations();
    };

    this.initializedesignations = function () {
      // invokes the initial designations call immediately and caches the default list
      var designationId = _this.model || _this.selectedId;

      if (_this.isCampaignContext) {
        return designationsService.getCampaignDesignations(_this.entity.id, { filter: 'id=' + designationId }).then(function (selected) {
          if (selected.data.data[0]) {
            _this.selectDesignation(selected.data.data[0].id, selected.data.data[0].name);
            return;
          }

          var currentDesignation = scCampaignsService.active.current.designation;
          if (_this.isCampaignContext && currentDesignation.id) {
            _this.selectDesignation(currentDesignation.id, currentDesignation.name);
            return;
          }

          // we default to the first designation in the list if a default is somehow not set in a campaign
          // eslint-disable-next-line consistent-return
          return _this.getDesignations().then(function (designations) {
            // get the first from the list that is not a group item for the typeahead
            var firstDesignation = designations.find(function (d) {
              return !d.isGroupItem;
            });
            _this.selectDesignation(firstDesignation.id, firstDesignation.name);
          });
        });
      }

      return designationsService.getOrganizationDesignations(_this.entity.id, 1, 1, designationId ? 'id=' + designationId : 'is_default=true').then(function (resp) {
        _this.selectDesignation(resp.data.data[0].id, resp.data.data[0].name);
      });
    };

    this.buildDesignationsByGroup = function (groups) {
      var designationsByGroup = {};

      // Only show group labels if the appropriate campaign setting is enabled
      groups.forEach(function (group) {
        // Only add the header if group.designations is not empty
        if (group.designations.length > 0) {
          designationsByGroup[group.name] = group.designations;
        }
      });

      return designationsByGroup;
    };

    this.buildUngroupedDesignations = function (designations) {
      var designationsSingleGroup = {};

      designationsSingleGroup[''] = designations;

      return designationsSingleGroup;
    };

    this.addDesignationsByGroup = function (designationsByGroup) {
      Object.keys(designationsByGroup).forEach(function (groupName) {
        var designations = designationsByGroup[groupName];

        if (!_this.designations[groupName]) {
          _this.designations[groupName] = [];
        }

        _this.designations[groupName] = _.union(_this.designations[groupName], designations);
        _this.designations[groupName] = _.uniqBy(_this.designations[groupName], 'id');
      });
    };

    this.buildTypeaheadItems = function () {
      var typeaheadItems = [];

      Object.keys(_this.designations).forEach(function (groupName) {
        if (groupName !== '') {
          typeaheadItems.push({
            isGroupItem: true,
            label: groupName
          });
        }

        typeaheadItems = _.union(typeaheadItems, _this.designations[groupName]);
      });

      return typeaheadItems;
    };

    this.forceRefresh = function () {
      _this.designationSortOrder = _this.entity.sort_designation_by;
      _this.sort = designationsService.parseSortOrder(_this.designationSortOrder);
      _this.getDesignations('', true);
    };

    this.getCampaignDesignationItems = function (filter) {
      return designationsService.getGroupedCampaignDesignations(_this.entity.id, {
        filter: filter,
        per_page: 100,
        page: _this.page,
        sort: _this.sort
      }).then(function (groups) {
        return _this.buildDesignationsByGroup(groups);
      });
    };

    this.getOrganizationDesignationItems = function (filter) {
      return designationsService.getOrganizationDesignations(_this.entity.id, 100, _this.page, filter).then(function (resp) {
        return _this.buildUngroupedDesignations(resp.data.data);
      });
    };
  }]
});
})();